import Button from "@mui/material/Button";
import { SxProps, Theme } from "@mui/material/styles";
import { LinkButtonProps } from "types";

const BASE_SX: SxProps<Theme> = {
  minWidth: 0,
  padding: 0,
  textTransform: "none",
  "&:hover": { textDecoration: "underline", backgroundColor: "transparent" },
};

const LinkButton = ({ sx, color = "secondary", ...props }: LinkButtonProps) => (
  <Button {...props} color={color} sx={sx ? [BASE_SX, ...(Array.isArray(sx) ? sx : [sx])] : BASE_SX} />
);

export default LinkButton;
